import { datadogClientAxiosErrorHandler } from '@mathflat/shared/@modules/datadog/axiosHandler'
import { DatadogClient } from '@mathflat/shared/@modules/datadog/datadogClient'
import { AxiosError } from 'axios'

import { envUtils } from '~/@common/utils/envUtils'

const datadogDebug = localStorage.getItem('DATADOG_DEBUG') ?? false

class StudentDatadogClient extends DatadogClient {
  axiosErrorHandler = datadogClientAxiosErrorHandler(this)

  constructor() {
    super({
      enabled:
        envUtils.isLive &&
        import.meta.env.VITE_BRAND !== 'schoolflat' &&
        import.meta.env.VITE_DATADOG_ENABLED === 'true',
      debug: datadogDebug,
      config: {
        applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
        clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
        service: import.meta.env.VITE_DATADOG_SERVICE_NAME,
        env: import.meta.env.VITE_VERCEL_ENV,
        version: import.meta.env.VITE_DATADOG_RELEASE_VERSION,
        // 학생 앱은 사용량이 많아 에러 트래킹 비용과 노이즈가 커질 수 있습니다.
        // RUM 부가 이벤트는 공용 beforeSend에서 차단하고, 학생 앱 에러 세션 자체는 50%만 수집합니다.
        sessionSampleRate: 50,
      },
    })
  }

  override sendError = (
    error: Error | AxiosError,
    context?: Parameters<DatadogClient['sendError']>[1],
  ) => {
    if (error instanceof AxiosError) {
      return this.axiosErrorHandler(error, context)
    }
    return super.sendError(error, context)
  }
}

export const datadogClient = new StudentDatadogClient()
